import { useEffect, useRef } from 'react';

import { useTurnstile } from 'hb-react/shared/components/Turnstile/useTurnstile';

import { SITE_KEY } from './constants';

export interface TurnstileProps {
  onError?: any;
  onExpire?: () => void;
  onSuccess?: (token: string) => void;
  siteKey?: string;
}

// Prevents errors from being thrown when the captcha fails or expires
const defaultErrorHandler = () => {};
const defaultExpireHandler = () => {};

export const TurnstileWidget = ({
  onSuccess,
  onError = defaultErrorHandler,
  onExpire = defaultExpireHandler,
  siteKey = SITE_KEY,
}: TurnstileProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const widgetId = useRef<string | null | undefined>(null);

  const { loaded: turnstileLoaded } = useTurnstile();

  useEffect(() => {
    if (!containerRef.current || !turnstileLoaded) {
      return;
    }

    const renderConfig = {
      sitekey: siteKey,
      callback: onSuccess,
      'error-callback': onError,
      'expired-callback': onExpire,
    };

    const render = () => {
      if (!containerRef.current || !window.turnstile) {
        return;
      }

      widgetId.current = window.turnstile.render(
        containerRef.current,
        renderConfig,
      );
    };

    render();

    return () => {
      if (widgetId.current && window.turnstile) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    };
  }, [onSuccess, onError, onExpire, turnstileLoaded, siteKey]);

  return <div ref={containerRef} />;
};
